export default __webpack_public_path__ + "static/media/template_2.a1bb67ee.png";